import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
  footer: {
    borderTop: '1px solid var(--border)',
    marginTop: '64px',
    padding: '32px 0 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px',
  },
  left: {
    fontSize: '12px',
    color: 'var(--text-muted)',
    maxWidth: '420px',
    lineHeight: 1.6,
  },
  logo: {
    fontFamily: 'var(--font-display)',
    color: 'var(--accent)',
    fontStyle: 'italic',
  },
  right: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
  },
  link: {
    fontSize: '11px',
    color: 'var(--text-muted)',
    textDecoration: 'none',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'color 0.15s',
  },
};

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.left}>
        © 2026 <span style={styles.logo}>Convert All Docs</span> — Convert files privately
      </div>
      <div style={styles.right}>
        <Link to="/" style={styles.link}>Home</Link>
        <Link to="/about" style={styles.link}>About</Link>
        <Link to="/contact" style={styles.link}>Contact</Link>
        <Link to="/terms" style={styles.link}>Terms</Link>
        <Link to="/privacy" style={styles.link}>Privacy</Link>
        <span style={styles.link} onClick={() => window.open('https://github.com', '_blank')}>GitHub</span>
      </div>
    </footer>
  );
}
